<template>
  <button
    class="hamburger hamburger--squeeze"
    type="button"
    :class="{ 'is-active': getSideMenuIsActive }"
    @click="toggleSideMenu"
  >
    <span class="hamburger-box">
      <span class="hamburger-inner"></span>
    </span>
  </button>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters('layout', ['getSideMenuIsActive']),
    },
    methods: {
      ...mapActions('layout', ['toggleSideMenu']),
    },
  };
</script>

<style scoped lang="scss">
  .hamburger {
    &[disabled] {
      opacity: 0.5;
    }
  }
</style>
